const schema = {
    photoId: {
        "label": "Upload your government issued photo ID:",
        "placeholder": "Click or drag document photo here",
        "required": "true"
    }
};

export default schema;